<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 8C12.5271 8 12.9922 7.79845 13.3953 7.39535C13.7985 6.99225 14 6.52713 14 6C14 5.47287 13.7985 5.00775 13.3953 4.60465C12.9922 4.20155 12.5271 4 12 4C11.4729 4 11.0078 4.20155 10.6047 4.60465C10.2015 5.00775 10 5.47287 10 6C10 6.52713 10.2015 6.99225 10.6047 7.39535C11.0078 7.79845 11.4729 8 12 8ZM10.6047 10.6047C11.0078 10.2015 11.4729 10 12 10C12.5271 10 12.9922 10.2015 13.3953 10.6047C13.7985 11.0078 14 11.4729 14 12C14 12.5271 13.7985 12.9922 13.3953 13.3953C12.9922 13.7985 12.5271 14 12 14C11.4729 14 11.0078 13.7985 10.6047 13.3953C10.2015 12.9922 10 12.5271 10 12C10 11.4729 10.2015 11.0078 10.6047 10.6047ZM10.6047 16.6047C11.0078 16.2015 11.4729 16 12 16C12.5271 16 12.9922 16.2015 13.3953 16.6047C13.7985 17.0078 14 17.4729 14 18C14 18.5271 13.7985 18.9922 13.3953 19.3953C12.9922 19.7985 12.5271 20 12 20C11.4729 20 11.0078 19.7985 10.6047 19.3953C10.2015 18.9922 10 18.5271 10 18C10 17.4729 10.2015 17.0078 10.6047 16.6047Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'MoreIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
